<template>
    <section class="mine-list">
        <div class="mine-list-item"
            v-for="(item, index) in dataSource"
            :key="index"
            @click="handleNavigate(item)">
            <!--<img class="layer"-->
                 <!--@click.stop = "$emit('closeLayer')"-->
                 <!--v-if="layer && index == dataSource.length - 1"-->
                 <!--src="../../assets/images/notice-layer.png" alt="">-->
            <div class="mine-list-item-icon">
                <img :src="item.icon" />
            </div>
            <div class="mine-list-item-name"
				:class="{ 'has-point': item.hasPoint}"

				:data-text="item.ultraText">
                {{ item.name }}
				<!-- 伪元素用作其它用途 -->
				<i></i>
            </div>
        </div>
        <!--<div class="mine-bg" v-if="layer" @click="$emit('closeLayer')">-->
          <!--<div class="mine-bg-btn" >-->
            <!--我知道了-->
          <!--</div>-->
        <!--</div>-->
    </section>
</template>

<script>
export default {
  name: 'MineList',
  props: {
    /**
     * 渲染的选项列表
     */
    dataSource: {
      type: Array,
      required: true
    }
  },

  methods: {
    handleNavigate (item) {
      if (item.handler) {
        item.handler(item)
      } else if (item.href) {
        this.$router.push(item.href)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    @import '../../style/main.scss';

    .mine-list {
        margin: rem(50) rem(30) 0;
        border-radius: 4px;
        box-shadow: 0 rem(12) rem(15) rgba(0, 0, 0, .2);
        background-color: #fff;
        .mine-bg {
          position: absolute;
          min-height: 110vh;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(#000, .4);
          z-index: 1;
          &-btn {
            position: absolute;
            width: rem(160);
            height: rem(60);
            line-height: rem(60);
            border: rem(3) solid $globalColor;
            font-weight: bolder;
            text-align: center;
            border-radius: rem(10);
            color: $globalColor;
            left: 50%;
            transform: translateX(-50%);
            bottom: rem(100);
          }
        }
        &-item {
            display: flex;
            align-items: center;
			position: relative;
            .layer {
              position: absolute;
              bottom: 0;
              width: rem(695);
              left: 50%;
              transform: translateX(-50%);
              z-index: 2;
            }
            &-icon {
                padding: 0 rem(32) 0 rem(46);
                width: rem(36);

                & > img {
                    display: block;
                    width: 100%;
                }
            }

            &-name {
                flex: 1;
                position: relative;
                padding: rem(45) 0;

				// tip文字
				&::before {
					content: attr(data-text);
					transform: translateY(-50%);
					position: absolute;
					top: 50%;
					right: rem(60);
					color: $globalColor;
				}

                & > i {
                    $w: rem(12);
                    content: '';
                    transform: translateY(-50%);
                    position: absolute;
                    top: 50%;
                    right: rem(30);
                    width: $w;
                    height: $w * 2;
                    background: {
                        image: url('../../assets/images/schedule-icon-arrow.png');
                        size: contain;
                        repeat: no-repeat;
                    }
                }

				&.has-point {
					// 圆点
					&::after {
						$size: rem(18);
						content: '';
						display: inline-block;
						position: relative;
						top: -5px;
						left: -2px;
						width: $size;
						height: $size;
						border-radius: 50%;
						background-color: $globalColor;
					}
				}
            }

            &:not(:last-child) {
                .mine-list-item-name {
                    border-bottom: 1px solid #e4e4e4;
                }
            }
        }
    }
</style>
